import { render, staticRenderFns } from "./AutoActions.vue?vue&type=template&id=35680c1d&scoped=true&"
import script from "./AutoActions.vue?vue&type=script&lang=js&"
export * from "./AutoActions.vue?vue&type=script&lang=js&"
import style0 from "./AutoActions.vue?vue&type=style&index=0&id=35680c1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35680c1d",
  null
  
)

export default component.exports